import { COLORS } from '@shared/config/colors/colors';
import { Tag } from '@vtbhome/juicyfront';
import { styled } from 'goober';
import { ReactNode } from 'react';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    overflow: hidden;
    background-color: ${COLORS.neutral_00};
`;

export const Title = styled('p')`
    font-size: 32px;
    font-weight: 600;
    line-height: 24px;
    color: ${COLORS.primary_50};
`;

export const Content = styled('div')`
    display: flex;
    padding: 20px;
    gap: 8px;
    flex-direction: column;
`;

export const SubTitleWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
    gap: 20px;
`;

export const StyledTag = styled(Tag)<{ children: ReactNode }>`
    color: ${COLORS.neutral_90} !important;
`;
